import { HotelModel, useGetHotel } from 'api-hooks/hotel';
import { Option } from 'baseui/select';
import { NavigationRoutes } from 'common/constants';
import { PreviousNavigation } from 'common/helpers/previous-navigation';
import CreateSelectComponent from 'components/elements/create-select-component';
import { camelizeKeys } from 'humps';
import { useRouter } from 'next/router';
import React from 'react';
import { useFormContext, useWatch } from 'react-hook-form';

import useNavigation from './use-navigation';

export default function useGetHotelRoom({ name }) {
  const [hotelRooms, setHotelRooms] = React.useState<Option[]>([]);
  const { control } = useFormContext();
  const { navigate } = useNavigation();
  const { asPath } = useRouter();

  const hotelId = useWatch({
    control,
    name,
  });

  const onClickCreate = React.useCallback(() => {
    PreviousNavigation.set(asPath);
    navigate(NavigationRoutes.HotelsView, { id: hotelId, editable: true });
  }, [asPath, hotelId, navigate]);

  const { isFetching } = useGetHotel(
    {
      id: hotelId,
    },
    {
      enabled: !!hotelId,
      onSuccess: (data) => {
        if (data.data) {
          const result: HotelModel = camelizeKeys(data.data) as HotelModel;
          setHotelRooms(
            result.hotelRooms
              .map((item) => ({
                id: item.id,
                label: `${item.type} (${item.size})`,
                disabled: false,
              }))
              .concat([
                {
                  id: 'action_create',
                  label: (
                    <div
                      style={{
                        padding: '8px 16px',
                      }}
                      key="action_create"
                    >
                      <CreateSelectComponent
                        onCreate={onClickCreate}
                        label="Create New"
                      />
                    </div>
                  ) as unknown as string,
                  disabled: true,
                },
              ]),
          );
        }
      },
    },
  );

  return {
    hotelId,
    isFetching,
    hotelRooms,
    setHotelRooms,
  };
}
